import { callExternalApi } from '../callExternalApi';

export interface HexEmbedResponse {
  url: string;
}

export const postHexEmbedUrl = async (accountIds: string[] = []) => {
  return callExternalApi<HexEmbedResponse>({
    url: 'api/hex/embed_url',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: { account_ids: accountIds }
  });
};
